<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Compliance BUS Value</div>
        <div>
          <bread-crumb
            :bread-crumbs="['Compliance IND', 'Compliance BUS Value']"
          />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <!-- <div class="ms-2 mt-1 subtitleFontsize">
        High Profile Parameters setup for Individual Values
      </div> -->
      <v-card-text>
        <v-card-title class="ms-2">
          <v-row class="">
            <v-btn depressed  class="me-5" small color="primary" @click="back()" outlined
              >Back</v-btn
            >

            <v-dialog persistent max-width="400px" v-model="dialog">
              <template v-slot:activator="{ on, attrs }">
                <v-row class="mt-0">
                  <v-col cols="12" md="3">
                    <v-btn depressed 
                      color="primary"
                      dark
                      small
                      class="mb-2 text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                      @click="editItem"
                    >
                    <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon> Add Value
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Type here to filter the table data."
                      hide-details
                      single-line
                      class="me-4"
                      dense
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>

              <v-card height="400px">
                <v-form v-model="valid" ref="form">
                  <v-toolbar color="secondary" dark flat dense>
                    <span>{{ formtitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn depressed  icon @click="onClickBack()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="my-3">
                    <!-- <v-row>
                      <v-col cols="12" md="12">
                        <label class="my-0 rounded labelFontsize required">
                          Customer Type
                        </label>
                        <v-text-field
                          dense
                          class="rounded"
                          disabled
                          outlined
                          placeholder="Customer Type"
                          background-color="grey lighten-4"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row> -->

                    <v-row>
                      <v-col>
                        <label
                          v-if="$route.query.name == 'Customer Type'"
                          class="my-0 rounded labelFontsize required"
                        >
                          ID Type Values
                        </label>
                        <label
                          v-if="$route.query.name != 'Customer Type'"
                          class="my-0 rounded labelFontsize required"
                        >
                          Values
                        </label>
                        <v-autocomplete
                          dense
                          outlined
                          class="rounded"
                          v-model="compliancebusDetails.value_type"
                          :items="parametersList"
                          placeholder="Value"
                          :rules="Value"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <!-- <v-row > 
                      <v-col>
                        <label class="my-0 rounded labelFontsize required">
                          Value Code
                        </label>
                        <v-autocomplete
                          dense
                          outlined
                          class="rounded"
                          v-model="compliancebusDetails.value_type"
                          :items="parametersList"
                          placeholder="Value"
                          :rules="Value"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row> -->

                    <v-row>
                      <v-col>
                        <label class="my-0 rounded labelFontsize required"
                          >Score</label
                        >
                        <v-autocomplete
                          dense
                          outlined
                          class="rounded"
                          v-model="compliancebusDetails.risk_score"
                          placeholder="Score"
                          :items="scoreName"
                          :rules="Risk_score"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label
                          class="my-0 rounded labelFontsize"
                          v-if="$route.query.name != 'Customer Type'"
                        >
                          Description
                        </label>
                        <label
                          class="my-0 rounded labelFontsize"
                          v-if="$route.query.name == 'Customer Type'"
                        >
                          Description (Customer Type)
                        </label>
                        <v-text-field
                          placeholder="Description"
                          dense
                          class="rounded"
                          small
                          v-model="compliancebusDetails.description"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <div class="d-flex justify-center">
                    <v-btn depressed 
                      small
                      color="primary"
                      min-width="170px"
                      @click="postList()"
                      v-if="!compliancebusDetails.number"
                      class="me-3 mb-5 text-capitalize"
                    >
                    <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
                    </v-btn>

                    <v-btn depressed 
                      small
                      outlined
                      color="primary"
                      min-width="170px"
                      @click="onClickBack()"
                      v-if="!compliancebusDetails.number"
                      class="text-capitalize"
                    >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
                    </v-btn>

                    <v-btn depressed 
                      small
                      v-if="compliancebusDetails.number"
                      color="primary"
                      min-width="170px"
                      @click="update()"
                      class="text-capitalize"
                    >
                    <v-icon small class="me-2">mdi-content-save-edit-outline</v-icon> Update
                    </v-btn>
                    <v-btn depressed 
                      small
                      outlined
                      color="primary"
                      min-width="170px"
                      @click="onClickBack()"
                      class="ms-2 text-capitalize"
                      v-if="compliancebusDetails.number"
                    >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </v-card-title>

        <template>
          <v-col cols="12" md="3" lg="3" xs="12" class="mt-3">
            <label style="font-size: 16px">
              Compliance Parameter:
              <b class="ms-3">{{ this.$route.query.risk_factor }}</b></label
            >
          </v-col>
        </template>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          dense
          :items="indvaluecompliance"
          :search="search"
          class="mt-5 p-i"
        >
          <template v-slot:item.is_active="{ item }">
            <v-switch
              v-model="item.is_active"
              height="0px"
              color="success"
              dense
              @change="isactiveupdatebuscomplivalue(item)"
            ></v-switch>
          </template>
          <template v-slot:item.is="{ item }">
            <v-switch v-model="item.is" height="0px" dense></v-switch>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small color="primary" class="mr-2" @click="editItem(item)">
              mdi-content-save-edit-outline
            </v-icon>
          </template>
          <!-- <template v-slot:item.actions="{ item }">
      
                <v-icon small color="green" class="mr-2" @click="editItem(item)">
                  md-home
                </v-icon>
      
              </template> -->
        </v-data-table>
        <OverlayPageVue :showOverlay="loaderOverlay" />
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import { complianceINDvalue } from "@/utils/validationCopy.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
export default {
  mixins: [alerts],
  name: "Compliance BUS Value",
  data() {
    return {
      ...complianceINDvalue,
      valid: false,
      dialog: false,
      loader: false,
      mask: ["##", "-", "##"],
      // valid: true,
      // dialogDelete: false,
      is_active: "",
      search: "",
      headers: [
        {
          text: "ID",
          value: "number",
          width: 50,
        },
        { text: "Value", value: "value_type", width: 100 },
        { text: "Score", value: "risk_score", width: 100 },

        { text: "Active", value: "is_active", sortable: false, width: 100 },
        { text: "Action", value: "actions", sortable: false, width: 0 },
      ],
      parametersList: [],
      scoreName: [],
      indvaluecompliance: [],
      editedIndex: -1,
      loaderOverlay: false,
      compliancebusDetails: {
        name: "",
        risk_score: "",
        description: "",
        value_type: "",
      },
      defaultItem: {
        name: "",
        risk_score: "",
        description: "",
        value_type: "",
      },
    };
  },
  components: {
    BreadCrumb,

    OverlayPageVue,
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add Category" : "Edit Category";
    },
  },
  mounted() {
    console.log("this.$route.query.id", this.$route.query.item);
    this.getallbusValues();
    this.getallbusScores();
    this.getallbusValueScoresdata();
  },

  watch: {
    dialog(val) {
      val || this.onClickBack();
    },
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async getallbusValues() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getCompliancebusvalues(
          this.$route.query.parameter.value_code
        );
        if (response.data.status_code === 200) {
          this.parametersList = response.data.data.map((i) => i.value);
          console.log("values", response);
          this.stoploader();
        } 
        // else if (response.data.status_code === 401) {
        //   this.parametersList = [];
        //   this.returnNewToken();
        //   this.getallbusValues();
        //   this.stoploader();
        // }
         else {
          this.parametersList = [];
          this.stoploader();
        }
      } catch (error) {
        this.parametersList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getallbusScores() {
      this.loader = true;
      try {
        const response = await commonService.getcompliancebusvalueScores(
          "Risk Points"
        );
        if (response.status === 200) {
          this.loader = false;
          this.scoreName = response.data.data.map((i) => i.value);
        }
        //  else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getallbusScores();
        // }
         else {
          this.showAlertError(response.data.message);
          this.loader = false;
        }
        console.log("getallparameters", response);
      } catch (error) {
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
        console.error(error);
      }
    },
    async getallbusValueScoresdata() {
      this.loader = true;
      try {
        const response = await setupService.getallbusValueScoresdata(
          this.$route.query.item.id
        );
        if (response.status === 200) {
          this.loader = false;
          this.indvaluecompliance = response.data.data;
        } 
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getallbusValueScoresdata();
        // }
         else {
          this.showAlertError(response.data.message);
          this.loader = false;
        }
        console.log("getallparameters", response);
      } catch (error) {
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
        console.error(error);
      }
    },
    async postList() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loader = true;
        if (this.editedIndex > -1) {
          Object.assign(
            this.indvaluecompliance[this.editedIndex],
            this.compliancebusDetails
          );
        } else {
          try {
            const responseData = await setupService.PostBUScompliancevalie(
              this.$route.query.id,
              this.compliancebusDetails
            );
            if (responseData && responseData.data.status_code== 200) {
              this.showAlertSuccess(responseData.data.message);
              this.getallbusValueScoresdata();
              setTimeout(() => {
                this.loader = false;
              }, 400);
            }
            //  else if (responseData.data.status_code === 401) {
            //   this.returnNewToken();
            //   this.postList();
            // }
          } catch (error) {
            console.log(error.response);
            this.showAlertError("Something went wrong please try again later.");
            this.loader = false;
          }

          this.onClickBack();
        }
      }
    },

    editItem(item) {
      console.log("item", item);
      this.editedIndex = this.indvaluecompliance.indexOf(item);
      this.compliancebusDetails = Object.assign({}, item);
      this.dialog = true;
      this.$refs.form.resetValidation();
    },
    async isactiveupdatebuscomplivalue(isactive) {
      console.log(isactive, "active");
      this.loader = true;
      if (this.editedIndex < -1) {
        Object.assign(
          this.indvaluecompliance[this.editedIndex],
          this.compliancebusDetails
        );
      } else {
        console.log(
          "prameterdetails ",
          JSON.stringify(this.compliancebusDetails)
        );
        try {
          const responseData = await setupService.updateStatusBUSValue(
            isactive.id,
            isactive.is_active
          );
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess("Status is Updated", "success");
            this.getallbusValueScoresdata();
          }
          //  else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.isactiveupdatebuscomplivalue(isactive);
          // }
        } catch (error) {
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
          console.log(error);
        }
      }
    },
    async update() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loader = true;
        if (this.editedIndex < -1) {
          Object.assign(
            this.indvaluecompliance[this.editedIndex],
            this.compliancebusDetails
          );
        } else {
          console.log(
            "compliancebusDetails ",
            JSON.stringify(this.compliancebusDetails)
          );
          try {
            const responseData = await setupService.updateBUSvalue(
              this.compliancebusDetails.number,
              this.compliancebusDetails
            );
            if (responseData && responseData.data.status_code== 200) {
              this.showAlertSuccess(responseData.data.message);
              this.getallbusValueScoresdata();

              setTimeout(() => {
                this.loader = false;
              }, 400);
            }
            //  else if (responseData.data.status_code === 401) {
            //   this.returnNewToken();
            //   this.update();
            // }
          } catch (error) {
            console.log(error);
            this.showAlertError("Something went wrong please try again later.");
          }
        }
      }
    },

    onClickBack() {
      this.dialog = false;
    },
    back() {
      this.$router.push({
        path: "/complianceBus",
      });
    },
  },
};
</script>
<style lang="css">
.required:after {
  content: " *";
  color: red;
}
</style>
